export default __webpack_public_path__ + "ef0e7d847190a4942be2ad5017a868ab.png";